import moment from "moment";
import "moment/dist/locale/es";
import "moment/dist/locale/fr";
import "moment/dist/locale/de";
import "../dependencies/i18n";

// Each moment locale import above SETS that locale as moment's current one, so
// the last import wins. Re-sync to the user's I18n locale (#4914).
moment.locale(I18n.locale.split("_")[0]);
import "../helpers/legacy/customLodashCompat";
import "../dependencies/jQuery";
import "../../../vendor/assets/javascripts/jquery_ujs";
// import "../../../app/assets/javascripts/tixxt.js.coffee"
import ClipboardJS from "clipboard/src/clipboard";

import "@hotwired/turbo";
import bridge from "../turbo/bridge.tsx";

// Stimulus
import "../controllers";

import { launchApp } from "../components/App";
import loadAndConfigureCKEditor from "../helpers/ckeditor/loadAndConfigureCKEditor";
import Datepicker from "../helpers/Datepicker";
import showCookieModal from "../helpers/showCookieModal";
import documentReady from "../helpers/documentReady";
import "../helpers/legacy/customLodashCompat";
import initializeCustomConfirm from "../turbo/confirm_compat.js";
import { fetchApi } from "../helpers/reactQueryApi";

// check if is access by app and do some configuration if so
const regex = new RegExp(/tixxt App/gm);
window.isApp = regex.test(window.navigator.userAgent);

// Expose bridge globally for native iOS/Android apps
window.bridge = bridge;

// Global helper stuff
if (window.isApp) {
  document.addEventListener("turbo:load", bridge.configureLayout);

  document.addEventListener("turbo:render", () => {
    const pageTitle = document.querySelector(
      "#static-page-title h1",
    )?.textContent;
    if (pageTitle) {
      bridge.setPageTitle(pageTitle);
    }
  });
}

window.loadAndConfigureCKEditor = loadAndConfigureCKEditor;
window.moment = moment;
window.ClipboardJS = ClipboardJS;
window.Datepicker = Datepicker;

documentReady(() => initializeCustomConfirm());

window.showCookieModal = showCookieModal;
window.fetchApi = fetchApi;

launchApp();
